import React, { useState, useEffect, useMemo } from 'react'
import { FormControl, FormGroup, Grid } from '@material-ui/core'
// import TimePicker from '@mui/lab/TimePicker'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { makeStyles } from '@material-ui/core/styles'
import dayjs from 'dayjs'
import { Checkbox } from './FormFields'
// Create custom CSS styles
const useStyles = makeStyles((theme) => ({
  container: {
    marginRight: '8px',
  },
  withTopMargin: {
    marginTop: '20px !important',
  },
  withMarginLeft: {
    marginLeft: '10px !important',
  },
  daysWrapper: {
    margin: '20px 0',
  },
}))

// "MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary Mui-focused MuiInputBase-formControl MuiInputBase-adornedEnd css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root"v>

const DayTimePicker = ({ schedule, onChange }) => {
  const classes = useStyles()
  const daysOfWeek = useMemo(
    () => [
      'Domingo',
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
    ],
    []
  )
  const [type, setType] = useState(schedule?.type || 'recurring')
  const [selectedDays, setSelectedDays] = useState(
    schedule && schedule.days
      ? schedule.days
          .split('')
          .map((bit, index) => (bit === '1' ? daysOfWeek[index] : null))
          .filter(Boolean)
      : []
  )
  const [selectedTimeStart, setSelectedTimeStart] = useState(
    schedule && schedule.startTime ? dayjs(schedule.startTime) : dayjs()
  )
  const [selectedTimeEnd, setSelectedTimeEnd] = useState(
    schedule && schedule.endTime ? dayjs(schedule.endTime) : dayjs()
  )
  const [selectedDateStart, setSelectedDateStart] = useState(
    schedule && schedule.startTime ? dayjs(schedule.startTime) : dayjs()
  )
  const [selectedDateEnd, setSelectedDateEnd] = useState(
    schedule && schedule.endTime ? dayjs(schedule.endTime) : dayjs()
  )

  useEffect(() => {
    // Establecer la hora actual como valor por defecto
    if (!schedule) {
      setSelectedTimeStart(dayjs())
      setSelectedTimeEnd(dayjs())
    }
  }, [schedule])

  const handleDayChange = (event) => {
    const selectedDay = event.target.name
    setSelectedDays((prevSelected) =>
      prevSelected.includes(selectedDay)
        ? prevSelected.filter((day) => day !== selectedDay)
        : [...prevSelected, selectedDay]
    )
  }

  useEffect(() => {
    // Skip effect if values aren't ready yet
    if (!selectedTimeStart || !selectedTimeEnd) return

    let startTime = dayjs(selectedTimeStart)
    let endTime = dayjs(selectedTimeEnd)

    if (selectedDateStart && selectedDateEnd && type === 'one_time') {
      // For one-time schedules, combine the date from selectedDateStart/End with time from selectedTimeStart/End
      startTime = dayjs(selectedDateStart)
        .hour(selectedTimeStart.hour())
        .minute(selectedTimeStart.minute())

      endTime = dayjs(selectedDateEnd)
        .hour(selectedTimeEnd.hour())
        .minute(selectedTimeEnd.minute())
    }

    onChange({
      startTime: startTime.toISOString(),
      endTime: endTime.toISOString(),
      days: daysOfWeek
        .map((day) => (selectedDays.includes(day) ? '1' : '0'))
        .join(''),
      type,
    })
  }, [
    selectedTimeStart,
    selectedTimeEnd,
    selectedDays,
    selectedDateStart,
    selectedDateEnd,
    type,
    daysOfWeek,
  ])

  return (
    <Grid container spacing={2} className={classes.container}>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <span>Frecuencia</span>
          <Checkbox
            field={{
              checked: type === 'recurring',
              onChange: () =>
                setType(type === 'recurring' ? 'one_time' : 'recurring'),
              label: 'Recurrente',
            }}
          />
        </FormControl>
        <br></br>
        {type === 'recurring' && (
          <>
            <FormControl component="fieldset" className={classes.daysWrapper}>
              <legend>Días de la semana</legend>
              <FormGroup>
                <div>
                  {daysOfWeek.map((day, index) => (
                    <Checkbox
                      field={{
                        checked: selectedDays.includes(day),
                        onChange: handleDayChange,
                        label: day,
                      }}
                    />
                  ))}
                </div>
              </FormGroup>
            </FormControl>
            <div style={{ display: 'flex' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Hora inicio"
                  value={selectedTimeStart}
                  onChange={(newValue) => setSelectedTimeStart(newValue)}
                  ampm={false}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Hora fin"
                  value={selectedTimeEnd}
                  onChange={(newValue) => setSelectedTimeEnd(newValue)}
                  ampm={false}
                  className={classes.withMarginLeft}
                />
              </LocalizationProvider>
            </div>
          </>
        )}
        {type === 'one_time' && (
          <>
            <FormGroup>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className={classes.withTopMargin}
                  label="Fecha inicio"
                  onChange={(newValue) => setSelectedDateStart(newValue)}
                  value={selectedDateStart}
                />
              </LocalizationProvider>
            </FormGroup>
            <FormGroup>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className={classes.withTopMargin}
                  label="Fecha fin"
                  onChange={(newValue) => setSelectedDateEnd(newValue)}
                  value={selectedDateEnd}
                />
              </LocalizationProvider>
            </FormGroup>
            <FormGroup>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Hora inicio"
                  value={selectedTimeStart}
                  onChange={(newValue) => setSelectedTimeStart(newValue)}
                  ampm={false}
                  className={classes.withTopMargin}
                />
              </LocalizationProvider>
            </FormGroup>
            <FormGroup>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Hora fin"
                  value={selectedTimeEnd}
                  onChange={(newValue) => setSelectedTimeEnd(newValue)}
                  ampm={false}
                  className={classes.withTopMargin}
                />
              </LocalizationProvider>
            </FormGroup>
          </>
        )}
      </Grid>
    </Grid>
  )
}

export default DayTimePicker
